import { RoseSocket } from './rosesocket';
import { RosePacket } from './rosepacket';

export class LoginClient {
    socket: any;

    constructor() {
      this.socket = new RoseSocket();
      this.socket.name = 'ls';
      this.socket.on('connect', function() {
        netConsole.debug('LoginClient connected');
      });
      this.socket.on('end', function() {
        netConsole.debug('LoginClient ended');
      });
    }

    son(event: any, handler: any) {
      const interHandler = (...args: any[]) => {
        if (!handler.apply(this, args)) {
          this.socket.removeEventListener(event, interHandler);
        }
      };
      this.socket.addEventListener(event, interHandler);
    }

    connect(host: any, port: any, callback: any) {
      this.socket.connect(host, port);
      this.son('connect', function(this: any) {
        const pak = new RosePacket(0x703);
        this.socket.sendPacket(pak);
        this.son('packet', function(pak: any) {
          if (pak.cmd !== 0x7ff) {
            console.warn('received unexpected preconn packet');
            return true;
          }
          callback();
        });
      });
    }

    end() {
      this.socket.end();
    }

    login(username: any, password: any, callback: any) {
      let opak = new RosePacket(0x708);
      const passwordMD5 = CryptoJS.MD5(password).toString(CryptoJS.enc.Hex);
      opak.addString(passwordMD5, true);
      opak.addString(username);
      this.socket.sendPacket(opak);
      this.son('packet', function(pak: any) {
        if (pak.cmd !== 0x708) {
          console.warn('received unexpected prelog packet');
          return true;
        }
        const data: any = {};
        data.result = pak.readUint8();
        data.right = pak.readUint16();
        data.payType = pak.readUint16();
        data.servers = [];
        while (!pak.isReadEof()) {
          const srvdata: any = {};
          srvdata.name = pak.readString();
          srvdata.id = pak.readUint32();
          data.servers.push(srvdata);
        }
        callback(data);
      });
    }

    channelList(serverId: any, callback: any) {
      let opak = new RosePacket(0x704);
      opak.addUint32(serverId);
      this.socket.sendPacket(opak);
      this.son('packet', function(pak: any) {
        if (pak.cmd !== 0x704) {
          return true;
        }
        if (pak.getUint32(0) !== serverId) {
          return true;
        }
        const data: any = {};
        /*serverId*/ pak.readUint32();
        const channelCount = pak.readUint8();
        data.channels = [];
        for (let i = 0; i < channelCount; ++i) {
          const chdata: any = {};
          chdata.id = pak.readUint8();
          chdata.lowAge = pak.readUint8();
          chdata.highAge = pak.readUint8();
          chdata.userPercent = pak.readInt16();
          chdata.name = pak.readString();
          data.channels.push(chdata);
        }
        callback(data);
      });
    }

    selectServer(serverId: any, channelId: any, callback: any) {
      const opak = new RosePacket(0x70a);
      opak.addUint32(serverId);
      opak.addUint8(channelId);
      this.socket.sendPacket(opak);
      this.son('packet', function(pak: any) {
        if (pak.cmd !== 0x70a) {
          return true;
        }
        const data: any = {};
        data.result = pak.readUint8();
        data.transferKey1 = pak.readUint32();
        data.transferKey2 = pak.readUint32();
        data.worldIp = pak.readString();
        data.worldPort = pak.readUint16();
        callback(data);
      });
    }

}

/**
 * @constructor
 */








